import type { ChristmasDinner2026FormData } from '../models/ChristmasDinner2026FormData'
import { formatDietaryRestrictions } from '../lib/dietaryOptions'
import { formatGalicianDate } from '../lib/formatGalicianDate'
import { priceFor } from '../lib/dinnerPrice'
import config from '../config/config'
import { emailLayout, escapeHtml } from './emailLayout'

export interface EmailContent {
  subject: string
  html: string
}

export const BUS_INFO = 'O bus gratuíto sairá dende a cafetaría The Movie, en Balaídos. Confirmaremos a hora máis adiante.'

const yesNo = (value: boolean): string => value ? 'Si' : 'Non'

const userDataBlock = (data: ChristmasDinner2026FormData): string => `
        <div class="user-data">
            <p><strong>Nome:</strong> ${escapeHtml(data.name)}</p>
            <p><strong>Apelidos:</strong> ${escapeHtml(data.lastName)}</p>
            <p><strong>Teléfono:</strong> ${escapeHtml(data.phone)}</p>
            <p><strong>E-mail:</strong> ${escapeHtml(data.email)}</p>
            <p><strong>Menor de 18 anos:</strong> ${yesNo(data.isMinor)}</p>
            <p><strong>Alimentación especial:</strong> ${escapeHtml(formatDietaryRestrictions(data.dietaryRestrictions, data.dietaryNotes))}</p>
            <p><strong>Precisa bus:</strong> ${yesNo(data.needsBus)}</p>
        </div>`

const hotelBlock = (): string => {
  const url = escapeHtml(config.HOTEL_URL)
  return `
        <div class="user-data">
            <p>Se queres pasar a noite, o Hotel Talaso Atlántico ofrécenos un ${config.HOTEL_DISCOUNT_PERCENT}% de desconto.
                Podes reservar a túa habitación directamente no hotel: <a href="${url}" target="_blank">${url}</a>
                co código promocional <strong>${escapeHtml(config.HOTEL_DISCOUNT_CODE)}</strong>.</p>
        </div>`
}

const minorAuthorizationBlock = (): string => `
        <p>Como es menor de idade, nas próximas semanas poñerémonos en contacto contigo para facilitarche o
            formulario que deberá asinar o teu pai, nai ou titor/a legal.</p>`

export const buildChristmasDinner2026ConfirmationEmail = (data: ChristmasDinner2026FormData): EmailContent => ({
  subject: 'Inscrición á cea de Nadal 2026 completada',
  html: emailLayout('Inscrición á cea de Nadal completada', `
        <p>Inscribícheste correctamente para asistir á nosa cea de Nadal 2026.</p>
        <p>A cea celebrarase o ${escapeHtml(formatGalicianDate(config.CHRISTMAS_DINNER_2026_DATE))}
            ${escapeHtml(config.CHRISTMAS_DINNER_2026_DETAILS)}.
            <a href="${escapeHtml(config.HOTEL_MAPS_URL)}" target="_blank">Ver no mapa</a></p>
        <p>A continuación, amosámoste os datos que nos proporcionaches no formulario para que verifiques que estea
            todo correcto:</p>${userDataBlock(data)}
        <p>Se ves que hai algún dato incorrecto, por favor, ponte en contacto con nós para que o modifiquemos.</p>
        ${data.isMinor ? minorAuthorizationBlock() : ''}
        ${data.needsBus ? `<p>${BUS_INFO}</p>` : ''}${hotelBlock()}
        <p>Lembra facer o pagamento de <strong>${priceFor(data.isMinor)} €</strong> por adiantado mediante transferencia
            ao IBAN ${escapeHtml(config.IBAN)}, indicando no asunto o teu nome e apelidos.</p>
        <br>`)
})

export const buildChristmasDinner2026AdminEmail = (data: ChristmasDinner2026FormData): EmailContent => ({
  subject: 'Nova inscrición para a cea de Nadal 2026',
  html: emailLayout('Nova inscrición para a cea', `
        <p>Rexistrouse unha nova inscrición para a cea de Nadal 2026.</p>
        <p>Estes son os datos enviados:</p>${userDataBlock(data)}
        <p>Descarga a listaxe de inscritos á cea de Nadal entrando na zona de exportacións: <br>
            <a href="https://formularios.lechuzascelestes.com/admin/exports" target="_blank">
                https://formularios.lechuzascelestes.com/admin/exports
            </a>
        </p>
        <br>`)
})
